export default function() {
    return <aside className="banner incidentinfo mobil info">
            <header>
                <h2>
                    DATEV RZ-Status mobil					
                </h2>
            </header>
            <p>
                    Immer und überall per App über Wartungen und Störungen im Rechenzentrum informiert sein.
            </p>
            <a className="button bannerButton" href="https://www.datev.de/hilfe/1080923" target="_blank" aria-label='Mehr Infos zur "DATEV RZ-Status mobil" App'>
                Weitere Infos
            </a>
        </aside>
}